import * as React from 'react';
export const ModalContext = React.createContext(null);
export const useModalContext = () => {
    const modalContext = React.useContext(ModalContext);
    if (!modalContext) {
        throw new Error('Context is undefined. Please verify you are calling useModalContext() within a Modal Step.');
    }
    return modalContext;
};
//# sourceMappingURL=ModalContext.js.map